import gql from 'graphql-tag'
import { ProfileFragmentGQL } from './fragments'

export const LoginGQL = gql`
  mutation login($credentials: AuthCredentials!) {
    login(credentials: $credentials) {
      accessToken
      refreshToken
    }
  }
`

export const SignUpGQL = gql`
    mutation SignUp(
      $name: String
      $phone: String
      $email: String
      $login: String
      $password: String
      $reCaptcha: String
    ) {
      signUp(params: {
        name: $name,
        phone: $phone,
        email: $email,
        login: $login,
        password: $password,
        reCaptcha: $reCaptcha
      }) {
        accessToken
        refreshToken
      }
    }
`

export const SingleUploadGQL = gql`
    mutation SingleUpload ($file: Upload!) {
      singleUpload(file: $file) {
        contentType
        name
        origin
        size
        path
      }
    }
`

export const MultipleUploadGQL = gql`
    mutation MultipleUpload ($files: [Upload!]!) {
      multipleUpload(files: $files) {
        contentType
        name
        origin
        size
        path
      }
    }
`

export const SingleUploadDeleteGQL = gql`
    mutation SingleUploadDelete ($fileName: String!) {
      singleUploadDelete (fileName: $fileName )
    }
`

export const AddMerchantGQL = gql`
  mutation AddMerchantProfile($params: MerchantProfileInput!, $draft: Boolean!) {
    addMerchantProfile(
      params: $params,
      draft: $draft
    ) {
        ...ProfileFragment
    }
  }
  ${ProfileFragmentGQL}
`

export const UpdateMerchantGQL = gql`
  mutation UpdateMerchantProfile($params: MerchantProfileInput!) {
    updateMerchantProfile(
      params: $params
    ) {
      ...ProfileFragment
    }
  }
  ${ProfileFragmentGQL}
`

export const AddOrderGQL = gql`
    mutation AddOrder($params: OrderInput!) {
      addOrder(params: $params) {
        id
        amount
        awardAggregator
        awardAmount
        canChangeStatus
        statusReason
        partnerApproved
        check {
          amount
          checkDate
          currency
          deviceUid
          fn
          number
          sourceQr
          manual
        }
        orderedAt
        currency
        currencyPartnerCommission
        source
        status
        user {
          firstName
          lastName
          patronymic
          approvedOrders
          declinedOrders
          externalUserId
          email
        }
      }
    }
`

export const ChangeOrderStatusGQL = gql`
    mutation ChangeOrderStatus($params: ChangeOrderStatusInput!) {
      changeOrderStatus(params: $params) {
        id
        status
        partnerApproved
      }
    }
`

export const UpdateResponseQrGQL = gql`
    mutation UpdateResponseQr {
      updateResponseQr
    }
`

export const GenerateNewAPIKeyGQL = gql`
    mutation GenerateNewAPIKey {
      generateNewApiKey {
        secretKey
      }
    }
`

export const AddWhiteListDomainGQL = gql`
    mutation AddWhiteListDomain($params: WhiteListDomainInput!) {
      addWhiteListDomain (params: $params) {
        crm
        domain
        id
      }
    }
`

export const DeleteWhiteListDomainGQL = gql`
    mutation DeleteWhiteListDomain($domainId: Int!) {
      deleteWhiteListDomain (domainId: $domainId)
    }
`

export const AddManagerGQL = gql`
    mutation AddManager ($params: ManagerProfileInput!) {
        addManager(params: $params) {
          id
          login
          name
          email
          phone
          owner
          isActive
        }
    }
`

export const UpdateManagerAccessGQL = gql`
    mutation UpdateManagerAccess ($params: ManagerInput!) {
        updateManagerAccess(params: $params) {
            partnerManagerId
            partnerAccessList {
              access
              role
            }
        }
    }
`

export const RechargeDepositGQL = gql`
    mutation RechargeDeposit ($params: RechargeDepositInput!) {
        rechargeDeposit(params: $params) {
            amount
            commission
            currency
            date
            debtAmount
            id
            number
            payAmount
            recharge
            status
            url
        }
    }
`

export const AddReferralGQL = gql`
  mutation AddReferral($params: AddReferralInput!) {
    addReferral(params: $params) {
        id
        needConfirm
        status
    }
  }
`

export const UpdateTerminalActivityGQL = gql`
    mutation UpdateTerminalActivity($id: Int!){
      updateTerminalActivity(id: $id) {
        active
        address
        id
        number
        shopId
        shopName
        terminalType
      }
    }
`

export const AddTerminalGQL = gql`
    mutation AddTerminal($params: AddTerminalInput!) {
      addTerminal(params: $params) {
        active
        address
        id
        number
        shopId
        shopName
        terminalType
      }
    }
`

export const UpdateTerminalGQL = gql`
  mutation UpdateTerminal($params: UpdateTerminalInput!) {
    updateTerminal(params: $params) {
      active
      address
      id
      number
      shopId
      shopName
      terminalType
    }
  }
`

export const ConfirmCodeGQL = gql`
    mutation ConfirmCode( $params: ConfirmTransactionInput! ) {
      confirmCode(params: $params) {
        id
        needConfirm
        status
      }
    }
`

export const ResendingConfirmCodeGQL = gql`
    mutation resendingConfirmCode( $params: ResendingConfirmCodeInput! ) {
      resendingConfirmCode(params: $params) {
        id
        needConfirm
        status
      }
    }
`

export const ChangeProfileStatusGQL = gql`
    mutation ChangeProfileStats( $params: ChangeProfileStatusInput!  ) {
      changeProfileStatus(params: $params) {
        ...ProfileFragment
      }
    }
    ${ProfileFragmentGQL}
`

export const ChangeActiveManager = gql`
    mutation ChangeActiveManager( $id: Int! ) {
      changeActiveManager (id: $id) {
        id
        email
        isActive
        login
        name
        owner
        phone
      }
    }
`

export const LoginByPinCodeGQL = gql`
    mutation LoginByPinCode($credentials: PinCodeCredentials!) {
      loginByPinCode(credentials: $credentials) {
        accessToken
        refreshToken
      }
    }
`

export const ResetPasswordGQL = gql`
mutation ResetPassword($params: ResetPassword!){
  resetPassword(params: $params)
}
`

export const RefreshTokenGQL = gql`
    mutation RefreshToken($credentials: RefreshTokenCredentials!) {
      refreshToken(credentials: $credentials) {
        accessToken
        refreshToken
      }
    }
`

export const RestorePassword = gql`
mutation RestorePassword($params: ResetPasswordAuth!){
  restorePassword(params: $params)
}
`

export const ResetPassPinCode = gql`
mutation ResetPassPinCode($params: ResetPasswordPinCode!){
  resetPassPinCode(params: $params)
}
`

export const DeleteMerchantGQL = gql`
mutation DeleteMerchant($params: InputDeleteMerchant!){
  deleteMerchant(params: $params)
}
`

export const ResetPass = gql`
mutation ResetPass($params: ResetPass!){
  resetPass(params: $params) {
    accessToken
    refreshToken
  }
}
`
